import React from "react";
import { Trans } from "react-i18next";
import TopNavigation from "../common/TopNavigation";


function PaymentScheduled(props) {
  const {  values, t } = props;

  const {vat, amount} = values;
  const price = parseInt(amount) + parseInt(vat);
  return (
    <div>
      <div className="container">
        <TopNavigation {...props} />
        <div className="row justify-content-md-center mt-3">
          <div className="col-sm-12 col-md-8">
            <div className="payment-summary p-4">
              <div className="row">
                <div className="col-sm-4">
                  <img
                    src="./images/payment-successful.svg"
                    alt="payment scheduled"
                    className="success-icon"
                  />
                </div>
                <div className="col-sm-6 dir-left">
                  <div className="row">
                    <div className="col-sm-12 mt-3">
                      <h2>{t("PAYMENT_SCHEDULED_TITLE")}</h2>
                      <div className="col-sm-12 my-4">
                        <p className="p-text">
                          <Trans i18nKey="PAYMENT_SCHEDULED_BODY" values={{ price }} components={{ bold: <strong /> }} />
                        </p>
                      </div>                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="download-app-sec col-sm-12 col-md-4 my-3 mt-md-0 ">
            <div className="p-3">
              <div className="row">
                <div className="col-sm-12">
                  <img src="./images/app-download-img.svg" alt="app download" />
                </div>
                <div className="col-sm-12 mt-3">
                  <h3>
                    {t("MANAGE_AND_TRACK_YOUR_SHIPMENTS_EASILY")}
                    <br />
                    <strong>{t("DOWNLOAD_THE_EMX_APP")}</strong>
                  </h3>
                </div>
                <div className="col-sm-12">
                  <a href={process.env.REACT_APP_EP_APP_DOWNLOAD_URL} target="_blank" className="a-link" rel="noreferrer">{t("LEARN_MORE")}</a>
                </div>
                {/* <div className="col-sm-12 mb-3">
                  <div className="row">
                    <div className="col-12 col-md-12 col-lg-6 ">
                      <TextInput
                        id="accountEmail"
                        name="accountEmail"
                        label={t("EMAIL_ADDRESS")}
                        placeholder=""
                        onChange={props.handleOnChange}
                        value={values.accountEmail}
                        validation={{ errors, dirty }}
                        t={t}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 mb-3">
                  <div className="row">
                    <div className="col-12 col-md-12 col-lg-6 ">
                      <PasswordInput
                        id="accountPassword"
                        name="accountPassword"
                        label={t("PASSWORD")}
                        placeholder=""
                        onChange={props.handlePasswordOnChange}
                        value={values.accountPassword}
                        validation={{ errors, dirty }}
                        t={t}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 mb-3">
                  <div className="row">
                    <div className="col-12 col-md-12 col-lg-6 ">
                      <div
                        className={
                          dirty.confirmPassword && !values.confirmPassword
                            ? "form-group invalid"
                            : "form-group"
                        }
                      >
                        <label htmlFor="confirmPassword">
                          {t("CONFIRM_PASSWORD")}
                        </label>
                        <input
                          id="confirmPassword"
                          name="confirmPassword"
                          type="password"
                          className="form-control"
                          value={values.confirmValue}
                          onChange={props.handlePasswordConfirmChange}
                        />
                        {dirty.confirmPassword && !values.confirmPassword && (
                          <div className="error-message">
                            {t("ERROR_PASSWORD_DOES_NOT_MATCH")}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 mt-4 mb-4">
                  <button className="btn btn-primary-outline">
                    {t("CREATE_NEW_ACCOUNT")}
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentScheduled;
